{
  "time_range_error_message": "Die Endzeit muss nach der Startzeit liegen",
  "attribute_list_items": "Elemente der Attributliste",
  "attribute_list_item": "Element in der Attributliste",
  "attribute_list_item_order": "Reihenfolge der Elemente in der Attributliste"
}